import {
  BrandBar,
  EvidencePanel,
  ScoreRing,
  SplChip,
  SplSentence,
  UnlockList,
} from '../components/index.js';
import { LegalFooter } from '../components/LegalFooter.js';
import { OFFERING } from '@shared/config.js';
import type { ScanResult } from '@shared/types.js';

const UNLOCK_ITEMS = [
  'The eight-category breakdown, with weights',
  `The ${OFFERING.deliverable} as a one-page PDF`,
  'What a Deep Scan would add',
] as const;

/**
 * Screen 3 — the score reveal.
 *
 * FULLY UNGATED, by deliberate design (build prompt §6.3). The score, band,
 * interpretation and evidence panel are all given outright. Nothing on this
 * screen is blurred, locked, teased or placeholder-ed; the form that follows
 * unlocks additional detail, it does not unlock the result.
 */
export default function ScoreReveal({
  result,
  onContinue,
}: {
  result: ScanResult;
  onContinue: () => void;
}) {
  return (
    <div className="app">
      <BrandBar tag="Your indicative result" />

      <main className="screen screen--scroll">
        <div className="score-grid">
          <div>
            <p className="score-cap">Your NDSS</p>
            <div className="scorewrap">
              <ScoreRing score={result.overall} />
              {/* SPL is the headline, matching the full NDSS (decision 2026-07-19). */}
              <div style={{ marginTop: 14 }}>
                <SplChip level={result.spl} size="lg" />
              </div>
              <SplSentence level={result.spl} />
            </div>
          </div>

          <div>
            <EvidencePanel />

            <div className="score-cta-grid">
              <UnlockList heading="Enter your details to get" items={UNLOCK_ITEMS} />
              <div>
                <button type="button" className="btn btn-primary btn-block" onClick={onContinue}>
                  Get my {OFFERING.deliverable}
                  <span className="btn-arrow" aria-hidden="true" />
                </button>
                <p
                  style={{
                    textAlign: 'center',
                    fontSize: 12,
                    color: 'var(--fg-muted)',
                    margin: '10px 0 0',
                  }}
                >
                  No demo call yet.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>

      <LegalFooter />
    </div>
  );
}
